import { observable, action, intercept } from "mobx";
import { post } from "../services/ajax.service";

class ChronicCareManagementStore {


  @observable behavioral = {};
  @observable cardiovascular = {};
  @observable diabetes_medications = {};
  @observable diabetes_equipments = {};
  @observable error = "";
  @observable all_list = [];
  @observable url = "/api/v1/chroniccaremanagementaction";

  return_unique_count = async (data) => {
    data['participants'] = (new Set(data.participants.replace(/,\s*$/, "").split(",").filter(a => a != ""))).size;
    console.log(data)
    return data
  }



  @action sortbydesc(filter) {
    this.filterValue = filter;
    if (this.all_list.length > 0) {

      if (filter == "label_name") {
        this.all_list = this.all_list.sort(function (a, b) {
          if (a.label_name > b.label_name) return -1;
          if (a.label_name < b.label_name) return 1;
          return 0
        })
      }

      if (filter == "total_spend") {
        this.all_list = this.all_list.sort(function (a, b) {
          if (parseInt(a.total_spend) > parseInt(b.total_spend)) return -1;
          if (parseInt(a.total_spend) < parseInt(b.total_spend)) return 1;
          return 0
        })
      }

      if (filter == "average_cost") {
        this.all_list = this.all_list.sort(function (a, b) {
          if (parseInt(a.average_cost) > parseInt(b.average_cost)) return -1;
          if (parseInt(a.average_cost) < parseInt(b.average_cost)) return 1;
          return 0
        })
      }

      if (filter == "fills") {
        this.all_list = this.all_list.sort(function (a, b) {
          if (parseInt(a.fills) > parseInt(b.fills)) return -1;
          if (parseInt(a.fills) < parseInt(b.fills)) return 1;
          return 0
        })
      }

      if (filter == "participants") {
        this.all_list = this.all_list.sort(function (a, b) {
          if (parseInt(a.participants) > parseInt(b.participants)) return -1;
          if (parseInt(a.participants) < parseInt(b.participants)) return 1;
          return 0
        })
      }
    }
  }

  @action sortbyasc(filter) {
    this.filterValue = filter;
    if (this.all_list.length > 0) {

      if (filter == "label_name") {
        this.all_list = this.all_list.sort(function (a, b) {
          if (a.label_name < b.label_name) return -1;
          if (a.label_name > b.label_name) return 1;
          return 0
        })
      }

      if (filter == "total_spend") {
        this.all_list = this.all_list.sort(function (a, b) {
          if (parseInt(a.total_spend) < parseInt(b.total_spend)) return -1;
          if (parseInt(a.total_spend) > parseInt(b.total_spend)) return 1;
          return 0
        })
      }

      if (filter == "average_cost") {
        this.all_list = this.all_list.sort(function (a, b) {
          if (parseInt(Math.round(a.average_cost)) < parseInt(Math.round(b.average_cost))) return -1;
          if (parseInt(Math.round(a.average_cost)) > parseInt(Math.round(b.average_cost))) return 1;
          return 0
        })
      }
      if (filter == "fills") {
        this.all_list = this.all_list.sort(function (a, b) {
          if (parseInt(a.fills) < parseInt(b.fills)) return -1;
          if (parseInt(a.fills) > parseInt(b.fills)) return 1;
          return 0
        })
      }


      if (filter == "participants") {
        this.all_list = this.all_list.sort(function (a, b) {
          if (parseInt(a.participants) < parseInt(b.participants)) return -1;
          if (parseInt(a.participants) > parseInt(b.participants)) return 1;
          return 0
        })
      }
      for(let i=0; i<58; i++){
        console.table(this.all_list[i].label_name, Math.round(this.all_list[i].average_cost));

      }

    }
  }










  @action getAll = async (data, type) => {
    this.all_list = [];
    try {
      let response = await post(
        `${this.url}/${type}`,
        data
      );
      this.all_list = response.data;
    } catch (err) {
      this.error = err.response;
      console.log(err);
    }
  }
  @action getBehavioral = async (data) => {
    this.behavioral = {};
    try {
      let response = await post(
        `${this.url}/getBehavioral`,
        data
      );

      this.behavioral = await this.return_unique_count(response.data[0]);
    } catch (err) {
      this.error = err.response;
      console.log(err);
    }
  }
  @action getCardiovascular = async (data) => {
    this.cardiovascular = {};
    try {
      let response = await post(
        `${this.url}/getCardiovascular`,
        data
      );

      this.cardiovascular = await this.return_unique_count(response.data[0]);
    } catch (err) {
      this.error = err.response;
      console.log(err);
    }
  }
  @action getDiabetesEquipments = async (data) => {
    this.diabetes_medications = {};
    try {
      let response = await post(
        `${this.url}/getDiabetesEquipments`,
        data
      );

      this.diabetes_medications = await this.return_unique_count(response.data[0]);
    } catch (err) {
      this.error = err.response;
      console.log(err);
    }
  }
  @action getDiabetesMedications = async (data) => {
    this.diabetes_equipments = {};
    try {
      let response = await post(
        `${this.url}/getDiabetesMedications`,
        data
      );

      this.diabetes_equipments = await this.return_unique_count(response.data[0]);
    } catch (err) {
      this.error = err.response;
      console.log(err);
    }
  }


}

export default ChronicCareManagementStore;
